import { useLocation } from 'react-router-dom';
import { useStoreState } from 'providers/StoreStateContext';
import { useGetLicenceConfiguration } from 'services/settings/individual';
import { navbarItems } from 'utils/navbar/navbarItems';
import { settingsNavbarItems } from 'utils/navbar/navbarSettingsItems';

export const useNavbarIcon = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const { applicationSettings } = useStoreState();
  const getLicenceConfiguration = useGetLicenceConfiguration();

  const findIconInNavbarItems = (items: any[]): any => {
    for (const item of items) {
      if (item.path === pathSegments[0]) {
        if (item.children && pathSegments.length > 1) {
          const childIcon = findIconInChildren(item.children, pathSegments.slice(1));
          if (childIcon) {
            return childIcon;
          }
        }
        return item.icon;
      }
      
      if (item.children) {
        const childIcon = findIconInNavbarItems(item.children);
        if (childIcon) {
          return childIcon;
        }
      }
    }
    return null;
  };

  const findIconInChildren = (children: any[], segments: string[]): any => {
    for (const child of children) {
      if (child.path === segments[0]) {
        return child.icon;
      }
    }
    return null;
  };

  if (pathSegments[0] === 'settings') {
    const settingsItems = settingsNavbarItems({
      isDemo: getLicenceConfiguration.data?.isDemo,
      clientUserAvailable: getLicenceConfiguration.data?.clientModuleAccess,
    });
    
    for (const item of settingsItems) {
      if (item.path === location.pathname.substring(1)) {
        return item.icon;
      }
    }
  }

  const icon = findIconInNavbarItems(
    navbarItems(
      getLicenceConfiguration.data?.clientModuleAccess,
      applicationSettings?.extensionContract
    )
  );
  return icon;
};